import React, { forwardRef, useImperativeHandle, useState } from 'react'
import { Form, Input, InputNumber, Modal, Select } from 'antd'
import { errorModal } from '../plugins/utils'
import {
  TABLE_FIELD_NUMBER_DEFAULT,
  TABLE_FIELD_NUMBER_MAX,
  TABLE_FIELD_NUMBER_MIN,
  TABLE_HEADER_TEXT_TYPES
} from '../common/tableHeaderConstants'

const typeOptions = [
  {
    label: '单行文本框',
    value: 'a'
  },
  {
    label: '多行文本框',
    value: 'b'
  },
  {
    label: '下拉列表',
    value: 's'
  },
  {
    label: '日期选择器',
    value: 't'
  }
]

/** 验证关系选项 */
const relationshipOptions = [
  { value: '>', label: '晚于' },
  { value: '>=', label: '晚于或等于' },
  { value: '=', label: '等于' },
  { value: '<=', label: '早于或等于' },
  { value: '<', label: '早于' },
]

const EditTableHeaderForm = forwardRef(({ selectOptions, saveTableHeadField }, ref) => {
  const [form] = Form.useForm()
  const [modalVisible, setModalVisible] = useState(false)

  useImperativeHandle(ref, () => {
    return {
      showModal
    }
  })

  const showModal = (row) => {
    setModalVisible(true)
    if (row) {
      form.setFieldsValue({
        name: row.name,
        type: row.type,
        content: row.content,
        description: row.description,
        relatedData: row.relatedData,
        relationship: row.relationship,
        fieldNumber: row.fieldNumber ?? TABLE_FIELD_NUMBER_DEFAULT,
        id: row.id
      })
    } else {
      form.setFieldsValue({
        fieldNumber: TABLE_FIELD_NUMBER_DEFAULT
      })
    }
  }

  const hideModal = () => {
    setModalVisible(false)
    form.resetFields()
  }

  const onOk = () => {
    form.validateFields().then((fields) => {
      const { type, relatedData, relationship } = fields;
      const uncompleteRelated = [relatedData, relationship].filter(item => !item).length === 1;
      if (type === 't' && uncompleteRelated) {
        errorModal(relatedData ? '请选择验证关系' : '请填写关联表头');
        return;
      }
      saveTableHeadField(fields)
      hideModal()
    }).catch(err => {
      console.error(err)
    })
  }

  return (<Modal
    title="编辑表头"
    open={ modalVisible }
    onCancel={ hideModal }
    onOk={ onOk }
  >
    <Form
      className={ 'my-3' }
      form={ form }
      labelCol={ { span: 8 } }
      wrapperCol={ { span: 12 } }
      initialValues={ {
        name: '',
        content: '',
        description: '',
        relatedData: '',
        fieldNumber: TABLE_FIELD_NUMBER_DEFAULT,
      } }
    >
      <Form.Item
        noStyle
        name={ 'id' }
      ></Form.Item>
      <Form.Item
        label={ '表头名称' }
        name={ 'name' }
        rules={ [{ required: true, message: '表头名称不能为空' }] }
      >
        <Input
          placeholder={ '例：工作单位' }
        ></Input>
      </Form.Item>
      <Form.Item
        label={ '字段类型' }
        name={ 'type' }
        rules={ [{ required: true, message: '请选择字段类型' }] }
      >
        <Select
          className={ 'mr-2' }
          options={ typeOptions }
          placeholder='选择字段类型'
          onChange={ (value) => {
            if (TABLE_HEADER_TEXT_TYPES.includes(value)) {
              const currentFieldNumber = form.getFieldValue('fieldNumber')
              if (currentFieldNumber == null || currentFieldNumber === '') {
                form.setFieldValue('fieldNumber', TABLE_FIELD_NUMBER_DEFAULT)
              }
            }
          } }
        ></Select>
      </Form.Item>
      <Form.Item
        noStyle
        shouldUpdate={ (prevValues, curValues) => prevValues.type !== curValues.type }
      >
        { ({ getFieldValue }) => {
          return getFieldValue('type') === 's'
            ? <Form.Item
              label={ '关联数据' }
              name={ 'content' }
              rules={ [{ required: true, message: '请选择字段类型' }] }
            >
              <Select options={ selectOptions }></Select>
            </Form.Item>
            : <></>
        } }
      </Form.Item>
      <Form.Item
        noStyle
        shouldUpdate={ (prevValues, curValues) => prevValues.type !== curValues.type }
      >
        { ({ getFieldValue }) => {
          return TABLE_HEADER_TEXT_TYPES.includes(getFieldValue('type'))
            ? <Form.Item
              label={ '最大字数' }
              name={ 'fieldNumber' }
            >
              <InputNumber
                min={ TABLE_FIELD_NUMBER_MIN }
                max={ TABLE_FIELD_NUMBER_MAX }
                precision={ 0 }
                style={ { width: '100%' } }
              ></InputNumber>
            </Form.Item>
            : <></>
        } }
      </Form.Item>
      <Form.Item
        label={ '字段说明' }
        name={ 'description' }
      >
        <Input.TextArea placeholder={ '输入字段说明' }></Input.TextArea>
      </Form.Item>
      <Form.Item
        noStyle
        shouldUpdate={ (prevValues, curValues) => prevValues.type !== curValues.type }
      >
        { ({ getFieldValue }) => getFieldValue('type') === 't'
          ? (
            <>
              <Form.Item label='关联表头' name='relatedData'>
                <Input placeholder='请输入关联表头' />
              </Form.Item>
              <Form.Item label='验证关系' name='relationship'>
                <Select options={ relationshipOptions } placeholder='请选择验证关系' allowClear />
              </Form.Item>
            </>
          )
          : <></>
        }
      </Form.Item>
    </Form>
  </Modal>)
})

export default EditTableHeaderForm
